import React, { useCallback } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getReportOfferModalVisible } from 'logic/store/modal/modal.selectors';
import { modalSlice } from 'logic/store/modal/modal.slice';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { ReportOfferForm } from './report-offer.form';

export const ReportOfferModal = () => {
  const dispatch = useDispatch();
  const { maxTablet } = useBreakpoints();
  const visible = useSelector(getReportOfferModalVisible);
  const handleClose = useCallback(() => {
    dispatch(modalSlice.actions.closeReportOfferModal());
  }, [dispatch]);

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      maskClosable
      footer={null}
      centered
      width={maxTablet ? '95%' : 500}
      style={{
        marginTop: 10,
        marginBottom: 10,
      }}
    >
      <ReportOfferForm />
    </Modal>
  );
};
